import {all, takeLatest} from "typed-redux-saga";
import {
	addPlayerToTeam,
	clearAllPlayers,
	fetchCountriesRequest,
	fetchPlayers,
	fetchSettings,
	fetchTeamSharingImage,
	fetchSquads,
	fetchUserTeams,
	fetchFanVotes,
	requestProfile,
	requestUser,
	saveProfile,
	saveUserTeamRequest,
	saveFanVotePlayer,
	fetchHelpJSONs,
	fetchFanVoteRankings,
	fetchArticles,
	fetchFavVoteSharingImage,
	addFanVotePlayer,
} from "modules/actions";
import {
	fetchCountriesSaga,
	fetchFanVoteRankingsSaga,
	fetchHelpJSONsSaga,
	fetchPlayersSaga,
	fetchSettingsSaga,
	fetchSquadsSaga,
	fetchArticlesSaga,
	fetchFavVoteSharingImageSaga,
} from "modules/sagas/json";
import {
	AddPlayerToTeamSideSaga,
	clearAllPlayersSaga,
	fetchTeamShareImageSaga,
	fetchUserTeamsSaga,
	saveUserTeamSaga,
} from "modules/sagas/team";
import {requestProfileSaga, requestUserSaga, saveProfileSaga} from "modules/sagas/user";
import {addFanVotePlayerSaga, fetchFanVotesSaga, saveFanVotePlayerSaga} from "modules/sagas/vote";

export const rootSaga = function* () {
	yield* all([
		/**
		 * Team
		 */
		takeLatest(addPlayerToTeam, AddPlayerToTeamSideSaga),
		takeLatest(clearAllPlayers, clearAllPlayersSaga),
		takeLatest(fetchUserTeams, fetchUserTeamsSaga),
		takeLatest(saveUserTeamRequest, saveUserTeamSaga),
		takeLatest(fetchTeamSharingImage, fetchTeamShareImageSaga),
		/**
		 * JSON
		 */
		takeLatest(fetchPlayers, fetchPlayersSaga),
		takeLatest(fetchSquads, fetchSquadsSaga),
		takeLatest(fetchSettings, fetchSettingsSaga),
		takeLatest(fetchCountriesRequest, fetchCountriesSaga),
		takeLatest(fetchHelpJSONs, fetchHelpJSONsSaga),
		takeLatest(fetchArticles, fetchArticlesSaga),
		/**
		 * User
		 */
		takeLatest(requestUser, requestUserSaga),
		/**
		 * Profile
		 */
		takeLatest(requestProfile, requestProfileSaga),
		takeLatest(saveProfile, saveProfileSaga),
		/**
		 * Fan vote
		 */
		takeLatest(fetchFanVotes, fetchFanVotesSaga),
		takeLatest(saveFanVotePlayer, saveFanVotePlayerSaga),
		takeLatest(fetchFanVoteRankings, fetchFanVoteRankingsSaga),
		takeLatest(fetchFavVoteSharingImage, fetchFavVoteSharingImageSaga),
		takeLatest(addFanVotePlayer, addFanVotePlayerSaga),
	]);
};
